import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import GymTransferStructure from "../../components/transfer/gym-transfer/GymTransferStructure";

const GymTransferSystem = () => {
  const userInfoData = useSelector(selectUser);

  return <GymTransferStructure userInfoData={userInfoData} />;
};

export default GymTransferSystem;